import { useState } from 'react';
import { Banner } from '@tackle-io/platform-ui';

/**
 * displays a list of fields that were not mapped due to errors
 * with default title and message
 */
export const DataMapperFieldErrorsBanner = ({
  defaultCollapsed = false,
  title = 'Some required fields could not be pre-filled from the opportunity.',
  message = 'To continue please complete all required fields. If this is unexpected, contact your Tackle administrator.',
}: {
  defaultCollapsed?: boolean;

  message?: string;
  title?: string;
}) => {
  const [isOpen, setIsOpen] = useState(!defaultCollapsed);

  return (
    <Banner
      body={message}
      borderPosition="top"
      isCollapsible
      onChange={() => setIsOpen((current) => !current)}
      open={isOpen}
      title={title}
      type="warning"
    />
  );
};
